import { render, staticRenderFns } from "./Asystent360MeshOrb.vue?vue&type=template&id=5db132d1&scoped=true"
import script from "./Asystent360MeshOrb.vue?vue&type=script&lang=ts"
export * from "./Asystent360MeshOrb.vue?vue&type=script&lang=ts"
import style0 from "./Asystent360MeshOrb.vue?vue&type=style&index=0&id=5db132d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.25_babel-core@6.26.3_css-loader@6.11.0_webpack@5.111_qiwspig4cowntqqutyssg3tktu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db132d1",
  null
  
)

export default component.exports